// extracted by mini-css-extract-plugin
export default {"wrapper":"J1VYaGpVdFJJi8oeYdID","highlightZone":"rdS6O2ohoS_zWpu3Ma1Q","periodsList":"W23CHPxkKHVi4AT247Nn"};